import SpinModel from "../../model/SpinModel";
import { ICondition } from "../State";
import { OverlayType } from "../../server/data/ISpinData";

export class HasExpandCondition implements ICondition {
    public check(): boolean {
        return SpinModel.hasOverlay(OverlayType.Expanding);
    }
}
